<template>
  <MultibarChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import MultibarChart from '@/components/cards/models/MultibarChart';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { DATA_TYPE } from '@/store/modules/cards/constants';
import sacListeningModel from '@/mixins/sac-listening-model';

export default {
  name: 'SentimentByThemes',
  components: {
    MultibarChart,
  },
  mixins: [
    sacListeningModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      classifiedPercentage: 0,
      filter: {},
    };
  },
  computed: {
    series() {
      const filteredThemes = this.filter.themes?.value;

      if (filteredThemes) {
        const filteredData = this.rawSeries.all?.filter(item => filteredThemes.includes(item.name)) || [];

        return {
          ...this.rawSeries,
          all: [...filteredData],
        };
      }

      return this.rawSeries;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getSacListeningWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }
      const promisses = [
        this.createRequisitions(DATA_TYPE.LISTENING),
        this.createRequisitions(DATA_TYPE.SAC),
      ];
      Promise.all(
        promisses
      ).then(([responseListening, responseSac]) => {
        this.rawSeries = this.aggregateResponses(responseListening.data, responseSac.data) || [];
        this.requestStatus = 'success';

        if (options?.silentRefresh) {
          EventBus.$emit('updated', { itemId: this.itemId });
        }
      }).catch(error => {
        console.error(error);
        this.requestStatus = 'error';
      });
    },
    createRequisitions(dataType) {
      return this.getSacListeningWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringMultibar',
        filterType: dataType,
        serviceParams: {
          type: 'themes',
        },
      });
    },
  },
};
</script>

<style scoped>
</style>
